import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useTable } from 'react-table';
import { downloadAndConvertFile } from '../../../../utils/fileUtils';

import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import DownloadIcon from '@mui/icons-material/Download';


export function CreateTableOld({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick, isEditMode }) {
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	const columns = React.useMemo(() =>
		dataHeader.map((header, index) => ({
			Header: header,
			accessor: dataAccessor[index]
		})),
		[dataHeader, dataAccessor]
	);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow
	} = useTable({ columns, data: dataList });

	const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
	const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
	const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

	const totalPages = Math.ceil(rows.length / itemsPerPage);
	const isLastPage = currentPage === totalPages;

	const paginate = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setCurrentPage(pageNumber);
		}
	};

	return (
		<div>
			<table {...getTableProps()} className='border-collapse'>
				<thead>
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th {...column.getHeaderProps()}>
									{
										column.render("Header")
									}
								</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{dataList.length <= 0 &&
						<tr>
							<td colSpan={columns.length} style={{ textAlign: "center" }}>
								No data to display
							</td>
						</tr>
					}
					{currentItems.map((row) => {
						prepareRow(row)
						return (
							<tr key={row.original.id}
								{...row.getRowProps()}
							>
								{row.cells.map((cell) => (
                                    // FIX 1: Wrap SetInfo in React.Fragment with unique key
									<React.Fragment key={cell.getCellProps().key}>
										{SetInfo(cell.render("Cell").props.column.Header,
											cell,
											row,
											editHandleClick,
											deleteHandleClick,
											isEditMode)}
									</React.Fragment>
								))}
							</tr>
						)
					})}
				</tbody>
			</table>
			{rows.length > itemsPerPage ? (
				<div>
					<div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
						<button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
							style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
							&lt;&lt;
						</button>
						<button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
							style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
							<NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
						</button>
						<button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
							style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "26px" }}>
							NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
						</button>
						<button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
							style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "26px" }}>
							&gt;&gt;
						</button>
					</div>
					{`${currentPage}/${totalPages}`}
				</div>
			) :
				<></>}
		</div>
	)
}

function SetInfo(header, _cell, _row, editHandleClick, deleteHandleClick, isEditMode) {
	const data = _cell.render("Cell").props.row.original;
	const value = _cell.render("Cell").props.value;

	if (header === "") {
		return (
			<td>
				{isEditMode ?
					<div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
						<Tooltip text="Update">
							<div style={{ padding: "0 5px" }} onClick={() => editHandleClick(data)}><ModeEditIcon /></div>
						</Tooltip>
						{deleteHandleClick ?
							<Tooltip text="Delete">
								<div style={{ padding: "0 5px" }} onClick={() => deleteHandleClick(data)}><DeleteForeverIcon /></div>
							</Tooltip>
							:
							<></>
						}
					</div>
					: <></>
				}
			</td>
		)
	}

	if (header === "Status") {
		if (data.isActive) {
			return (
				<td>
					Active
				</td>
			)
		}
		else {
			return (
				<td>
					InActive
				</td>
			)
		}
	}

	if (header === "Approved?") {
		return (
			<td>
				<input type="checkbox"
					id="overtime-allowance"
					className="checkbox"
					name=""
					checked={data.isActive}
					disabled={true}
				/>
			</td>
		)
	}

	if (header === "Time From") {
		const time = _cell.render("Cell").props.row.original.timeFrom;

		const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
		let hours = parseInt(timeParts[0], 10);
		const minutes = timeParts[1];

		// Convert 24-hour format to 12-hour format and determine AM or PM
		const amPm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

		const formattedTime = `${hours}:${minutes} ${amPm}`;

		return (
			<td>
				{formattedTime}
			</td>
		);
	}

	if (header === "Time To") {
		const time = _cell.render("Cell").props.row.original.timeTo;

		const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
		let hours = parseInt(timeParts[0], 10);
		const minutes = timeParts[1];

		// Convert 24-hour format to 12-hour format and determine AM or PM
		const amPm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

		const formattedTime = `${hours}:${minutes} ${amPm}`;

		return (
			<td>
				{formattedTime}
			</td>
		);
	}

	if (header === "Date"
		|| header === "Date From"
		|| header === "Date To"
		|| header === "Date Processed"
		|| header === "Request Date"
		|| header === "Date Of Birth"
	) {
		if (!value) {
			return (
				<td>
				</td>
			);
		}
		const date = new Date(_cell.render("Cell").props.value);
		if (!date) {
			return (
				<td>
					null
				</td>
			);
		}

		const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
		const dd = date.getDate();
		const yyyy = date.getFullYear();

		const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

		return (
			<td>
				{formattedDateFrom}
			</td>
		)
	}

	if (header === "File") {
		// compute the derived filename from the title
		const fileName = _row.original.fileName ?? "";

		// console.log(_row.original);

		return (
			<td key={header}>
				{fileName ? (
					<button
						onClick={() => downloadAndConvertFile(_row.original.file, _row.original.fileName)}
						style={{
							color: "#1d4ed8",
							textDecoration: "underline",
							background: "none",
							border: "none",
							cursor: "pointer",
						}}
					>
						{fileName}
					</button>
				) : (
					<span>No File</span>
				)}
			</td>
		);
	}

	//Double type data
	if (header === "Over Percentage"
		|| header === "Deduction"
		|| header === "Salary"
		|| header === "Employee"
		|| header === "Employer"
		|| header === "Range From"
		|| header === "Range To	"
		|| header === "Monthly Salary"
		|| header === "SSS ER"
		|| header === "SSS EE"
		|| header === "SSS Total"
		|| header === "ECER"
		|| header === "Total Contribution ER"
		|| header === "Total Contribution EE"
		|| header === "Total Contribution Total"
		|| header === "SE Total Contribution"
		|| header === "Salary Range From"
		|| header === "Salary Range To"
		|| header === "Total Monthly Premium"
		|| header === "Percentage"
		|| header === "Amount"
		|| header === "Total Loan"
		|| header === "Total Balance"
		|| header === "Default Deduction"
		|| header === "Allowance"
		|| header === "Daily Salary"
		|| header === "Allowance"
		|| header === "Total Basic"
		|| header === "Rate"
		|| header === "Hours OT Regular"
		|| header === "Total OT Regular"
		|| header === "Hours OT Exceeded"
		|| header === "Total OT Exceeded"
		|| header === "Hours OT Restday"
		|| header === "Total OT Restday"
		|| header === "Hours Holiday Special"
		|| header === "Total Holiday Special"
		|| header === "Hours Holiday Regular"
		|| header === "Total Holiday Regular"
		|| header === "Hours Restday Holiday Special"
		|| header === "Total Restday Holiday Special"
		|| header === "Hours Restday Holiday Regular"
		|| header === "Total Restday Holiday Regular"
		|| header === "Additions"
		|| header === "SSS"
		|| header === "Pagibig"
		|| header === "Philhealth"
		|| header === "SSS Loan"
		|| header === "SSS Calamity Loan"
		|| header === "Pagibig Loan"
		|| header === "Pagibig Calamity Loan"
		|| header === "Tax"
		|| header === "Deductions"
		|| header === "Adjustments"
		|| header === "Total Net Pay"
		|| header === "Days Absent"
		|| header === "Absent/s"
		|| header === "Days Leave"
		|| header === "Leave/s"
		|| header === "Hours Exceeded"
		|| header === "Total Exceeded"
		|| header === "Hours Undertime"
		|| header === "Undertime"
		|| header === "Hours Late"
	) {
		const value = _cell.render("Cell").props.value;

		// Check if value is a number
		const isNumber = typeof value === 'number';

		const numberWithCommasAndDecimal = (number) => {
			return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		};

		if (!isNumber) {
			return (
				<td {..._cell.getCellProps()}> {
					_cell.render("Cell")
				}
				</td>
			)
		}

		const formattedNumber = numberWithCommasAndDecimal(value);

		return (
			<td>
				{formattedNumber}
			</td>
		)
	}

	return (
		<td {..._cell.getCellProps()}> {
			_cell.render("Cell")
		}
		</td>
	)
}

export function CreateTableOld2({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, downloadHandleClick, isEditMode }) {
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	const columns = React.useMemo(() =>
		dataHeader.map((header, index) => ({
			Header: header,
			accessor: dataAccessor[index]
		})),
		[dataHeader, dataAccessor]
	);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow
	} = useTable({ columns, data: dataList });

	const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
	const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
	const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

	const totalPages = Math.ceil(rows.length / itemsPerPage);
	const isLastPage = currentPage === totalPages;

	const paginate = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setCurrentPage(pageNumber);
		}
	};

	return (
		<div>
			<table {...getTableProps()} className='border-collapse'>
				<thead>
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th {...column.getHeaderProps()}>
									{
										column.render("Header")
									}
								</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{dataList.length <= 0 &&
						<tr>
							<td colSpan={columns.length} style={{ textAlign: "center" }}>
								No data to display
							</td>
						</tr>
					}
					{currentItems.map((row) => {
						prepareRow(row)
						return (
							<tr key={row.original.id}
								{...row.getRowProps()}
							>
								{row.cells.map((cell) => (
                                    // FIX 2: Wrap SetInfo2 in React.Fragment with unique key
									<React.Fragment key={cell.getCellProps().key}>
										{SetInfo2(cell.render("Cell").props.column.Header,
											cell,
											editHandleClick,
											downloadHandleClick,
											isEditMode)}
									</React.Fragment>
								))}
							</tr>
						)
					})}
				</tbody>
			</table>
			{rows.length > itemsPerPage ? (
				<div>
					<div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
						<button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
							style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
							&lt;&lt;
						</button>
						<button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
							style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
							<NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
						</button>
						<button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
							style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "26px" }}>
							NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
						</button>
						<button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
							style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "26px" }}>
							&gt;&gt;
						</button>
					</div>
					{`${currentPage}/${totalPages}`}
				</div>
			) :
				<></>}
		</div>
	)
}
function SetInfo2(header, _cell, editHandleClick, downloadHandleClick, isEditMode) {
	const data = _cell.render("Cell").props.row.original;
	const value = _cell.render("Cell").props.value;

	if (header === "") {
		return (
			<td>
				{isEditMode ?
					<div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
						<Tooltip text="Update">
							<div style={{ padding: "0 5px" }} onClick={() => editHandleClick(data)}><ModeEditIcon /></div>
						</Tooltip>
					</div>
					: <></>
				}
			</td>
		)
	}
	if (header === "Category") {
		if(!value) return (<td> - </td>);
	}
	if (header === "File") {
		if (!value) {
			return (<td>No uploaded file yet.</td>)
		}

		return (
			<td>
				<div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
					{downloadHandleClick ?
						<Tooltip text="Download">
							<div style={{ padding: "0 5px" }} onClick={() => downloadHandleClick(data)}><DownloadIcon
								className='cursor-pointer rounded-md text-blue-500 hover:bg-blue-500 hover:text-white'
								style={{ border: "1px solid #2196F3" }}
							/></div>
						</Tooltip>
						:
						<></>
					}
				</div>
			</td>
		)
	}

	if (header === "Status" || header === "Is Active?") {
		if (data.isActive) {
			return (
				<td>
					Active
				</td>
			)
		}
		else {
			return (
				<td>
					InActive
				</td>
			)
		}
	}
	if (header === "Has Completed?") {
		if (value) {
			return (
				<td>
					Yes
				</td>
			)
		}
		else {
			return (
				<td>
					No
				</td>
			)
		}
	}

	if (header === "Approved?") {
		return (
			<td>
				<input type="checkbox"
					id="overtime-allowance"
					className="checkbox"
					name=""
					checked={data.isActive}
					disabled={true}
				/>
			</td>
		)
	}

	if (header === "Time From") {
		const time = _cell.render("Cell").props.row.original.timeFrom;

		const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
		let hours = parseInt(timeParts[0], 10);
		const minutes = timeParts[1];

		// Convert 24-hour format to 12-hour format and determine AM or PM
		const amPm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

		const formattedTime = `${hours}:${minutes} ${amPm}`;

		return (
			<td>
				{formattedTime}
			</td>
		);
	}

	if (header === "Time To") {
		const time = _cell.render("Cell").props.row.original.timeTo;

		const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
		let hours = parseInt(timeParts[0], 10);
		const minutes = timeParts[1];

		// Convert 24-hour format to 12-hour format and determine AM or PM
		const amPm = hours >= 12 ? 'PM' : 'AM';
		hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

		const formattedTime = `${hours}:${minutes} ${amPm}`;

		return (
			<td>
				{formattedTime}
			</td>
		);
	}

	if (header === "Date"
		|| header === "Date From"
		|| header === "Date To"
		|| header === "Date Processed"
		|| header === "Request Date"
		|| header === "Date Of Birth"
	) {
		if (!value) {
			return (
				<td>
				</td>
			);
		}
		const date = new Date(_cell.render("Cell").props.value);
		if (!date) {
			return (
				<td>
					null
				</td>
			);
		}

		const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
		const dd = date.getDate();
		const yyyy = date.getFullYear();

		const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

		return (
			<td>
				{formattedDateFrom}
			</td>
		)
	}

	//Double type data
	if (header === "Over Percentage"
		|| header === "Deduction"
		|| header === "Salary"
		|| header === "Employee"
		|| header === "Employer"
		|| header === "Range From"
		|| header === "Range To	"
		|| header === "Monthly Salary"
		|| header === "SSS ER"
		|| header === "SSS EE"
		|| header === "SSS Total"
		|| header === "ECER"
		|| header === "Total Contribution ER"
		|| header === "Total Contribution EE"
		|| header === "Total Contribution Total"
		|| header === "SE Total Contribution"
		|| header === "Salary Range From"
		|| header === "Salary Range To"
		|| header === "Total Monthly Premium"
		|| header === "Percentage"
		|| header === "Amount"
		|| header === "Total Loan"
		|| header === "Total Balance"
		|| header === "Default Deduction"
		|| header === "Allowance"
		|| header === "Daily Salary"
		|| header === "Allowance"
		|| header === "Total Basic"
		|| header === "Rate"
		|| header === "Hours OT Regular"
		|| header === "Total OT Regular"
		|| header === "Hours OT Exceeded"
		|| header === "Total OT Exceeded"
		|| header === "Hours OT Restday"
		|| header === "Total OT Restday"
		|| header === "Hours Holiday Special"
		|| header === "Total Holiday Special"
		|| header === "Hours Holiday Regular"
		|| header === "Total Holiday Regular"
		|| header === "Hours Restday Holiday Special"
		|| header === "Total Restday Holiday Special"
		|| header === "Hours Restday Holiday Regular"
		|| header === "Total Restday Holiday Regular"
		|| header === "Additions"
		|| header === "SSS"
		|| header === "Pagibig"
		|| header === "Philhealth"
		|| header === "SSS Loan"
		|| header === "SSS Calamity Loan"
		|| header === "Pagibig Loan"
		|| header === "Pagibig Calamity Loan"
		|| header === "Tax"
		|| header === "Deductions"
		|| header === "Adjustments"
		|| header === "Total Net Pay"
		|| header === "Days Absent"
		|| header === "Absent/s"
		|| header === "Days Leave"
		|| header === "Leave/s"
		|| header === "Hours Exceeded"
		|| header === "Total Exceeded"
		|| header === "Hours Undertime"
		|| header === "Undertime"
		|| header === "Hours Late"
	) {
		const value = _cell.render("Cell").props.value;

		// Check if value is a number
		const isNumber = typeof value === 'number';

		const numberWithCommasAndDecimal = (number) => {
			return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		};

		if (!isNumber) {
			return (
				<td {..._cell.getCellProps()}> {
					_cell.render("Cell")
				}
				</td>
			)
		}

		const formattedNumber = numberWithCommasAndDecimal(value);

		return (
			<td>
				{formattedNumber}
			</td>
		)
	}

	return (
		<td {..._cell.getCellProps()}> {
			_cell.render("Cell")
		}
		</td>
	)
}

const Tooltip = ({ text, children }) => {
	const [show, setShow] = useState(false);

	const handleMouseEnter = () => {
		setShow(true);
	};

	const handleMouseLeave = () => {
		setShow(false);
	};

	return (
		<div style={{ position: 'relative', display: 'inline-block', zIndex: "1" }}>
			<div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
				{children}
			</div>
			{show && (
				<div
					style={{
						position: 'absolute',
						top: '50%',
						left: '-50%',
						transform: 'translateX(-50%)',
						backgroundColor: 'white',
						color: 'gray',
						padding: '5px',
						borderRadius: '5px',
						pointerEvents: "none",
						boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
					}}
				>
					{text}
				</div>
			)}
		</div>
	);
};